import { ShortCode } from '@highereducation/wordpress';
import { ExpertBio } from '@highereducation/hen-ui';

type ExpertBioShortcodeProps = {
  'img-src'?: string;
  'img-alt'?: string;
  name?: string;
  occupation?: string;
  'brand-link-href'?: string;
  'brand-link-label'?: string;
  expertise?: string;
  size?: 'lg' | 'sm';
  border?: 'none' | 'paddingOnly';
  [key: string]: unknown;
};

/**
 * ExpertBioShortcode - Shortcode wrapper for ExpertBio composite component.
 *
 * @example
 * [hen-ui-expert-bio img-src="..." img-alt="..." name="Jane Doe" occupation="Editor" brand-link-href="..." brand-link-label="View profile" expertise="Psychology" /]
 */
export const ExpertBioShortcode: ShortCode<ExpertBioShortcodeProps> = {
  component: ({
    'img-src': imgSrc,
    'img-alt': imgAlt,
    name = '',
    occupation,
    'brand-link-href': brandLinkHref,
    'brand-link-label': brandLinkLabel,
    expertise,
    size = 'sm',
    border = 'none',
  }) => {
    if (!imgSrc || !imgAlt || !name) return null;
    const brandLink =
      brandLinkHref && brandLinkLabel
        ? { href: brandLinkHref, label: brandLinkLabel }
        : undefined;
    const highlight = expertise?.trim()
      ? { label: 'Expertise', text: expertise.trim() }
      : undefined;
    return (
      <ExpertBio
        imgSrc={imgSrc}
        imgAlt={imgAlt}
        name={name}
        occupation={occupation}
        brandLink={brandLink}
        highlight={highlight}
        size={size}
        border={border}
      />
    );
  },
};
